import React from 'react'

export default function NoItemsFound() {
  return (
    <div>No Items Found</div>
  )
}
